
Emitter = require('component-emitter')

global = window['srm']["methodsMap"]
events = global['events'] = new Emitter()


do () ->

    #console.log('events.js')

    window.onscroll = () ->
        events.emit('window:scroll')
        return

    ## test page flip prevention in ibooks (works)
    #document.addEventListener('touchmove', (e) ->
    #    e.preventDefault()
    #)

    resizeDebouncer = null
    window.onresize = () ->
        clearTimeout(resizeDebouncer)
        resizeDebouncer = setTimeout(() ->
            events.emit('window:resize')
            return
        , 300)
        return

    window.onbeforeunload = () =>
        events.emit('window:onbeforeunload')
        return

    return
